<!-- Base dialog component that wraps the entire filter dialog -->
<dhp-filter-dialog [filterName]="filterName()">
  <div class="flex h-full w-full flex-col overflow-hidden">
    <dhp-filter-date-range (dateRangeOutput)="dateRangeOutput.emit($event)" />
  </div>
</dhp-filter-dialog>
